export default __webpack_public_path__ + "static/media/1857.4fb52ed4.png";